module.exports = {
	"name": "@hrj/doppiojvm-snapshot",
	"version": "0.4.14",
	"engine": "node >= 4.0.0",
	"license": "MIT",
	"main": "dist/release/doppio.js",
	"typings": "dist/typings/src/doppiojvm",
	"dependencies": {
		"async": "^1.5.2",
		"browserfs": "^0.5.12",
		"glob": "^7.0.3",
		"gunzip-maybe": "^1.3.1",
		"optimist": "~0.6",
		"pako": "^1.0.1",
		"rimraf": "^2.5.2",
		"source-map-support": "^0.4.0",
		"tar-fs": "^1.12.0"
	},
	"devDependencies": {
		"bfs-buffer": "^0.1.7",
		"bfs-path": "^0.1.2",
		"bfs-process": "^0.1.6",
		"body-parser": "^1.15.1",
		"cpr": "^1.1.1",
		"detect-browser": "^1.3.1",
		"escodegen": "^1.8.0",
		"esprima": "^2.7.2",
		"estraverse": "^4.2.0",
		"express": "^4.13.4",
		"grunt": "^1.0",
		"grunt-cli": "^1.2",
		"grunt-contrib-compress": "^1.2.0",
		"grunt-contrib-connect": "^1.0",
		"grunt-contrib-copy": "^1.0",
		"grunt-contrib-uglify": "^1.0",
		"grunt-karma": "^1.0",
		"grunt-lineending": "^0.2.4",
		"grunt-merge-source-maps": "^0.1.0",
		"grunt-newer": "^1.2.0",
		"grunt-ts": "^5.5",
		"grunt-webpack": "^1.0.11",
		"imports-loader": "^0.6.5",
		"jasmine-core": "^2.3.4",
		"json-loader": "^0.5.4",
		"karma": "^0.13.22",
		"karma-chrome-launcher": "^1.0",
		"karma-firefox-launcher": "^1.0",
		"karma-ie-launcher": "^1.0",
		"karma-jasmine": "^1.0",
		"karma-opera-launcher": "^1.0",
		"karma-safari-launcher": "^1.0",
		"locate-java-home": "^0.1.4",
		"semver": "^5.1.0",
		"source-map-loader": "^0.1.5",
		"typescript": "^1.8.10",
		"uglify-js": "^2.6.2",
		"underscore": "^1.8.3",
		"webpack": "^1.13.1",
		"webpack-dev-server": "^1.14.1"
	},
	"scripts": {
		"test": "grunt test",
		"prepublish": "node ./prepublish.js",
		"install": "node ./install.js",
		"appveyor-test": "grunt test-browser-appveyor"
	},
	"repository": {
		"type": "git",
		"url": "http://github.com/plasma-umass/doppio.git"
	},
	"bin": {
		"doppio": "./bin/doppio",
		"doppioh": "./bin/doppioh",
		"doppio-dev": "./bin/doppio-dev",
		"doppio-fast-dev": "./bin/doppio-fast-dev"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 44
 ** module chunks = 0
 **/